// @ts-nocheck: converted from JS

import Approval from '@/components/Studies/Approval';

export default Approval;
